import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { sharedMessages } from '../../utils/uiMessages';

function NavIcon({ children }) {
  return (
    <svg
      className="patent-dashboard__nav-icon"
      viewBox="0 0 24 24"
      aria-hidden="true"
      fill="currentColor"
      width="18"
      height="18"
      focusable="false"
      style={{ flex: '0 0 18px', display: 'block' }}
    >
      {children}
    </svg>
  );
}

function navLinkClass(currentPath, targetPath, extra = '') {
  const targets = Array.isArray(targetPath) ? targetPath : [targetPath];
  const active = targets.includes(currentPath)
    ? ' patent-dashboard__nav-link--active'
    : '';
  return `patent-dashboard__nav-link${active}${extra ? ` ${extra}` : ''}`;
}

export default function AppNav({ currentPath = '' }) {
  const intl = useIntl();
  const token = useSelector((state) => state.userSession?.token);
  const authHref = token
    ? '/logout?return_url=/today'
    : '/login?return_url=/today';

  return (
    <nav className="patent-dashboard__nav" aria-label="Patent manager">
      <div className="patent-dashboard__nav-main">
        <Link className={navLinkClass(currentPath, '/today')} to="/today">
          <NavIcon>
            <path d="M12 2.8a9.2 9.2 0 1 0 9.2 9.2A9.2 9.2 0 0 0 12 2.8Zm4.1 10H12a1 1 0 0 1-1-1V6.9h2v4h3.1Z" />
          </NavIcon>
          {intl.formatMessage(sharedMessages.today)}
        </Link>
        <Link
          className={navLinkClass(currentPath, ['/overview', '/patent-dashboard'])}
          to="/overview"
        >
          <NavIcon>
            <path d="M12 3.8 2.8 11h1.9v9.2h5.6v-5.7h3.4v5.7h5.6V11h1.9L12 3.8Z" />
          </NavIcon>
          {intl.formatMessage(sharedMessages.overview)}
        </Link>
        <Link className={navLinkClass(currentPath, '/matters')} to="/matters">
          <NavIcon>
            <path d="M5 4.5h5.6l1.5 1.8H19a1.8 1.8 0 0 1 1.8 1.8v9.4A1.8 1.8 0 0 1 19 19.3H5A1.8 1.8 0 0 1 3.2 17.5V6.3A1.8 1.8 0 0 1 5 4.5Z" />
          </NavIcon>
          {intl.formatMessage(sharedMessages.matters)}
        </Link>
        <Link className={navLinkClass(currentPath, '/jobs')} to="/jobs">
          <NavIcon>
            <path d="M6.2 4.8h11.6A1.4 1.4 0 0 1 19.2 6.2v11.6a1.4 1.4 0 0 1-1.4 1.4H6.2a1.4 1.4 0 0 1-1.4-1.4V6.2a1.4 1.4 0 0 1 1.4-1.4Zm2.1 3.1a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2Zm3.1.4v1.4h5.1V8.3h-5.1Zm-3.1 4.1a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2Zm3.1.4v1.4h5.1v-1.4h-5.1Zm-3.1 4.1a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2Zm3.1.4v1.4h5.1v-1.4h-5.1Z" />
          </NavIcon>
          {intl.formatMessage(sharedMessages.jobs)}
        </Link>
        <Link className={navLinkClass(currentPath, '/tools')} to="/tools">
          <NavIcon>
            <path d="m21 7.2-4.2 4.2-1.7-1.7 4.2-4.2a1.2 1.2 0 0 1 1.7 0l0 0a1.2 1.2 0 0 1 0 1.7ZM13.9 7l3.1 3.1-7.7 7.7-4 1 1-4L13.9 7Zm-8.1 9.8.8.8-1.5.4.3-1.2.4 0Z" />
          </NavIcon>
          {intl.formatMessage(sharedMessages.tools)}
        </Link>
      </div>
      <div className="patent-dashboard__nav-auth">
        <a className="patent-dashboard__nav-link" href={authHref}>
          <NavIcon>
            {token ? (
              <path d="M10.2 3.5h7.1A1.7 1.7 0 0 1 19 5.2v13.6a1.7 1.7 0 0 1-1.7 1.7h-7.1a1.7 1.7 0 0 1-1.7-1.7v-3h2.7v1.7h5.1V5.9h-5.1v1.7H8.5v-2.4a1.7 1.7 0 0 1 1.7-1.7Zm-1 6.9v3.2H3.8l2.1 2.1-1.9 1.9L.6 12l3.4-3.6 1.9 1.9-2 2.1h5.3Z" />
            ) : (
              <path d="M6.7 3.5h7.1a1.7 1.7 0 0 1 1.7 1.7v3h-2.7V5.9H7.7v12.2h5.1v-2h2.7v2.7a1.7 1.7 0 0 1-1.7 1.7H6.7A1.7 1.7 0 0 1 5 18.8V5.2a1.7 1.7 0 0 1 1.7-1.7Zm7.3 6.9h6.2L18 8.3l1.9-1.9 3.5 3.6-3.5 3.6-1.9-1.9 2.2-2.3H14v-1.9Z" />
            )}
          </NavIcon>
          {token
            ? intl.formatMessage(sharedMessages.logOut)
            : intl.formatMessage(sharedMessages.logIn)}
        </a>
      </div>
    </nav>
  );
}
